import { render, staticRenderFns } from "./ProfileProgressChart.vue?vue&type=template&id=79056187&"
import script from "./ProfileProgressChart.vue?vue&type=script&lang=js&"
export * from "./ProfileProgressChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports